import { defineComponent as _defineComponent } from 'vue'
import { useAutoCycleList } from '@composables';

import Icon from '@components/Icon.vue';

import { faQuoteLeft } from '@icons/solid/faQuoteLeft';
import { faQuoteRight } from '@icons/solid/faQuoteRight';
import { faUser } from '@icons/solid/faUser';

export interface CustomerStory {
  id: string;
  body: string;
  author: string;
  image: string;
}

/** `SectionCustomerStories` component properties. */
export interface Props {
  stories: CustomerStory[];
}


const INTERVAL_DURATION = 8_000;

const __default__ = { name: 'SectionCustomerStories' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    stories: null
  },
  setup(__props: any) {

const props = __props as {
  stories: CustomerStory[];
};



const { state, paused, start, stop, select } = useAutoCycleList(
  props.stories,
  INTERVAL_DURATION,
);

const animationDuration = (INTERVAL_DURATION * 0.001).toString() + 's';

return { __sfc: true,INTERVAL_DURATION, props, state, paused, start, stop, select, animationDuration, Icon, faQuoteLeft, faQuoteRight, faUser }
}

})